
namespace RioERP.Masters {
    export class EmailTemplateVariablesColumns {
        static columnsKey = 'Masters.EmailTemplateVariables';
    }
}